import React from "react"
import {ManagedSolutionsTransaction} from "../../resources/managedSolutions"
import {DataTable, DataTableBody, DataTableCell, DataTableHead, DataTableRow} from "../DataTable/DataTable"
import PagingNavBar from "../PagingNavBar/PagingNavBar"
import classNames from "classnames"
import {startCase} from "lodash"
import moment from "moment"
import {Meta} from "../../resources/common"
import numeral from "numeral"

function generateSummary(summary: string) {
	const splitByPipe = summary.split("|")

	return (
		<>
			{splitByPipe.map((summaryPart, index) => {
				return (
					<span key={index}>
						<span>{summaryPart}</span>
						{index < splitByPipe.length - 1 ? <span className="has-text-grey-light">|</span> : null}
					</span>
				)
			})}
		</>
	)
}

interface ManagedSolutionsTransactionsTableProps {
	transactions: Array<ManagedSolutionsTransaction>
	hasResults: boolean
	hasPrev: boolean
	hasNext: boolean
	prev: () => void
	next: () => void
	isUsingPaging: boolean
	fullHeight?: boolean
	meta?: Meta
	sortFunction: () => void
	sortBy: string
}

export default function ManagedSolutionsTransactionsTable({
	transactions,
	hasPrev,
	hasNext,
	prev,
	next,
	hasResults,
	isUsingPaging,
	fullHeight,
	meta,
	sortFunction,
	sortBy,
}: ManagedSolutionsTransactionsTableProps) {
	const noContent = transactions.length === 0

	return (
		<div className={"managed-solutions-transactions-table"}>
			<DataTable
				isEmpty={noContent}
				fullHeight={fullHeight}
				noContentText="No transactions yet"
				clickable={false}
				hoverable={false}
			>
				<DataTableHead className={classNames(!fullHeight && "no-sticky")}>
					<DataTableRow>
						<DataTableCell>ID</DataTableCell>
						<DataTableCell>Type</DataTableCell>
						<DataTableCell>Balance</DataTableCell>
						<DataTableCell>Summary</DataTableCell>
						<DataTableCell>Amount</DataTableCell>
						<DataTableCell clickable onClick={() => sortFunction()} sortable sortApplied={sortBy === "createdAt"}>
							Created At
						</DataTableCell>
					</DataTableRow>
				</DataTableHead>
				<DataTableBody>
					{transactions.map((transaction) => {
						const transactionType = transaction.attributes.transactionType
						const amount = transaction.attributes.amount
						const balance = transaction.attributes.balance
						const summary = generateSummary(transaction.attributes.summary)
						const createdAt = transaction.attributes.createdAt
						const direction = transaction.attributes.direction

						return (
							<DataTableRow key={transaction.id}>
								<DataTableCell className="data-table-id-cell">{transaction.id}</DataTableCell>
								<DataTableCell>{startCase(transactionType)}</DataTableCell>
								<DataTableCell className={classNames(balance < 0 && "has-text-danger")}>
									{numeral(balance / 100).format("$0,0.00")}
								</DataTableCell>
								<DataTableCell style={{whiteSpace: "pre-wrap"}}>{summary}</DataTableCell>
								<DataTableCell
									className={classNames(
										direction === "Credit" && "has-text-success",
										direction === "Debit" && "has-text-danger"
									)}
								>
									{numeral(amount / 100).format("$0,0.00")}
								</DataTableCell>
								<DataTableCell style={{whiteSpace: "nowrap"}}>{moment(createdAt).format("L LT")}</DataTableCell>
							</DataTableRow>
						)
					})}
				</DataTableBody>
			</DataTable>
			<PagingNavBar
				hasResults={hasResults}
				hasPrev={hasPrev}
				hasNext={hasNext}
				prev={prev}
				next={next}
				isShow={isUsingPaging}
				meta={meta}
			/>
		</div>
	)
}
